<div class="checkbox-group">
  @for(option of options(); track $index;){
    <label 
      class="checkbox-option"
      [class.disabled]="disabled || !editMode()">
      <input
        type="checkbox"
        [checked]="isOptionSelected(option)"
        (change)="selectOption(option.value)"
        [disabled]="disabled || !editMode()"
      />
      <span class="checkbox-custom"></span>
      <span class="checkbox-label">{{ option.label }}</span>
    </label>
  }
</div>